"use strict";

exports.__esModule = true;
exports.ConfiguratorReducers = void 0;
var number = function number(store, action) {
  if (action.type === 'INC_NUMBER') {
    return {
      value: store.value + 1
    };
  }
  if (action.type === 'DEC_NUMBER') {
    return {
      value: store.value - 1
    };
  }
  return store || {
    value: 0
  };
};
var color = function color(store, action) {
  if (action.type === 'configurator/SET_COLOR') {
    return {
      value: action.value
    };
  }
  if (action.type === 'configurator/RESET_OPTIONS') {
    return {
      value: ''
    };
  }
  return store || {
    value: ''
  };
};
var fabric = function fabric(store, action) {
  if (action.type === 'configurator/SET_FABRIC') {
    return {
      value: action.value
    };
  }
  if (action.type === 'configurator/RESET_OPTIONS') {
    return {
      value: ''
    };
  }
  return store || {
    value: ''
  };
};
var fuelType = function fuelType(store, action) {
  if (action.type === 'configurator/SET_FUEL_TYPE') {
    return {
      value: action.value
    };
  }
  if (action.type === 'configurator/CLEAR_ALL_PREFERENCES') {
    return {
      value: ''
    };
  }
  return store || {
    value: ''
  };
};
var driveType = function driveType(store, action) {
  if (action.type === 'configurator/SET_DRIVE_TYPE') {
    return {
      value: action.value
    };
  }
  if (action.type === 'configurator/CLEAR_ALL_PREFERENCES') {
    return {
      value: ''
    };
  }
  return store || {
    value: ''
  };
};
var transmissionType = function transmissionType(store, action) {
  if (action.type === 'configurator/SET_TRANSMISSION_TYPE') {
    return {
      value: action.value
    };
  }
  if (action.type === 'configurator/CLEAR_ALL_PREFERENCES') {
    return {
      value: ''
    };
  }
  return store || {
    value: ''
  };
};
var model = function model(store, action) {
  if (action.type === 'configurator/SET_MODEL') {
    return {
      value: action.value
    };
  }
  return store || {
    value: ''
  };
};
var trimLine = function trimLine(store, action) {
  if (action.type === 'configurator/SET_TRIM_LINE') {
    return {
      value: action.value
    };
  }
  return store || {
    value: ''
  };
};
var packages = function packages(store, action) {
  if (action.type === 'configurator/SET_PACKAGES') {
    return {
      value: action.value
    };
  }
  if (action.type === 'configurator/RESET_OPTIONS') {
    return {
      value: []
    };
  }
  return store || {
    value: []
  };
};
var accessories = function accessories(store, action) {
  if (action.type === 'configurator/SET_ACCESSORIES') {
    return {
      value: action.value
    };
  }
  if (action.type === 'configurator/RESET_OPTIONS') {
    return {
      value: []
    };
  }
  return store || {
    value: []
  };
};
var incompatibleCodes = function incompatibleCodes(store, action) {
  if (action.type === 'configurator/SET_INCOMPATIBLECODES') {
    return {
      value: action.value
    };
  }
  if (action.type === 'configurator/RESET_OPTIONS') {
    return {
      value: []
    };
  }
  return store || {
    value: []
  };
};
var summaryExpanded = function summaryExpanded(store, action) {
  if (action.type === 'configurator/SET_SUMMARY_EXPAND') {
    return {
      value: action.value
    };
  }
  return store || {
    value: false
  };
};
var summaryDocked = function summaryDocked(store, action) {
  if (action.type === 'configurator/SET_SUMMARY_DOCKED') {
    return {
      value: action.value
    };
  }
  return store || {
    value: false
  };
};
var dataLossModal = function dataLossModal(store, action) {
  if (action.type === 'configurator/SET_DATA_LOSS_MODAL') {
    return {
      desiredStep: action.step,
      value: action.value
    };
  }
  return store || {
    value: false
  };
};
var changeModelModal = function changeModelModal(store, action) {
  if (action.type === 'configurator/SET_CHANGE_MODEL_MODAL') {
    return {
      value: action.value
    };
  }
  return store || {
    value: false
  };
};
var ConfiguratorReducers = exports.ConfiguratorReducers = {
  number: number,
  color: color,
  fabric: fabric,
  fuelType: fuelType,
  driveType: driveType,
  transmissionType: transmissionType,
  model: model,
  trimLine: trimLine,
  packages: packages,
  accessories: accessories,
  incompatibleCodes: incompatibleCodes,
  summaryExpanded: summaryExpanded,
  summaryDocked: summaryDocked,
  dataLossModal: dataLossModal,
  changeModelModal: changeModelModal
};